$(function () {
	const svgContainer = document.querySelector('.b-relationship__svg');

	if (!svgContainer) {
		return;
	}

	let WIDTH = svgContainer.offsetWidth;
	let HEIGHT = svgContainer.offsetHeight;
	const BEZIER_OFFSET = 120;
	const MAIN_COLOR = '#3366CC';
	const DISABLE_COLOR = '#c4c4c4';

	const mainContainer = document.querySelector('.b-relationship');
	const mainOffset = {
		top: mainContainer.offsetTop,
		left: mainContainer.offsetLeft
	};

	const cardMap = {};
	const nodeMap = {};

	const cardsData = mainContainer.querySelectorAll('[data-map-card]');

	if (cardsData.length > 0) {
		for (const card of cardsData) {
			const {mapCard, cardType} = card.dataset;

			cardMap[mapCard] = {
				html: card,
				type: cardType,
				nodeList: [],
			};
		}
	}

	const nodesData = mainContainer.querySelectorAll('[data-map-node]');

	if (nodesData.length > 0) {
		for (const node of nodesData) {
			const {mapNode, nodeParent, nodeTarget} = node.dataset;

			const targets = JSON.parse(nodeTarget);

			nodeMap[mapNode] =
				{
					html: node,
					nodeId: mapNode,
					parentId: nodeParent,
					targets
				};

			cardMap[nodeParent].nodeList.push(+mapNode);
		}
	}

	let nodePathMapById = createNodePathMapById(nodeMap);
	let nodeCoordMap = getNodesCoords(nodeMap, mainOffset);

	/**
	 * Создание карты связи узлов по ID
	 *
	 * @param nodeMap
	 * @returns [number[]]
	 */
	function createNodePathMapById(nodeMap) {
		const sourceTargetMap = [];
		const clearPoints = [];

		for (const node in nodeMap) {
			if (!nodeMap.hasOwnProperty(node)) {
				continue;
			}

			const nodePaths = nodeMap[node].targets.map(t => ([+node, t]));

			sourceTargetMap.push(
				...nodePaths
			);
		}

		for (const [source, target] of sourceTargetMap) { // удаляем дубли парных двувонаправленных путей
			const existPath = sourceTargetMap.find(([start, end]) => {
				return start === target && end === source;
			});

			if (existPath) {
				sourceTargetMap.splice(sourceTargetMap.indexOf(existPath), 1);
			}

			clearPoints.push([source, target]);
		}

		return clearPoints;
	}

	/**
	 * Получениек координат узлов на странице
	 *
	 * @param nodeMap
	 * @returns {{}}
	 */
	function getNodesCoords(nodeMap) {
		const coordMap = {};
		for (const node in nodeMap) {
			if (!nodeMap.hasOwnProperty(node)) {
				continue;
			}

			const {offsetTop, offsetLeft} = nodeMap[node].html;

			const n = nodeMap[node];

			if (cardMap[n.parentId].type === 'second') {
				let left = cardMap[n.parentId].html.offsetLeft + cardMap[n.parentId].html.offsetWidth;
				coordMap[node] = [left - 8, offsetTop + 10];
			} else {
				coordMap[node] = [offsetLeft, offsetTop + 10];
			}
		}
		return coordMap;
	}

	/**
	 * Получение списка активных путей на основе списка узлов
	 *
	 * @param activeNodeList
	 * @returns {*}
	 */
	function getActiveNodeId(activeNodeList) {
		return nodePathMapById.filter(
			([source, target]) => activeNodeList.includes(source) || activeNodeList.includes(target)
		).reduce((res, current) => ([...res, ...current]), []);
	}

	if (window.matchMedia('(max-width: 768px)').matches) {
		initMobileRelationships();
	} else {
		window.addEventListener('load', () => {
			initRelationships();
		});
	}

	function initRelationships() {

		WIDTH = svgContainer.offsetWidth;
		HEIGHT = svgContainer.offsetHeight;

		const svg = d3.select('.b-relationship__svg').append('svg')
			.attr('width', WIDTH)
			.attr('height', HEIGHT);

		nodeCoordMap = getNodesCoords(nodeMap, mainOffset);

		let pathData = createPathData(nodePathMapById, nodeCoordMap);

		const path = svg.selectAll('path')
			.data(pathData)
			.enter()
			.append('path')
			.style('opacity', 0)
			.attr('d', function ([[x1, y1], [x2, y2]]) {
				return draw(d3.path(), x1+6, y1, x1 + BEZIER_OFFSET, y1, x2 - BEZIER_OFFSET, y2, x2, y2);
			})
			.attr('stroke-width', 2)
			.attr('stroke', MAIN_COLOR)
			.attr('fill', 'none');


		path.transition()
			.duration(300)
			.style('opacity', 1);

		const rombGroup = svg.selectAll('g')
			.data(pathData)
			.enter()
			.append('g')
			.style('opacity', 0)
			.each(function (d) {
				const [[x, y]] = d;
				d3.select(this)
					.attr('transform', `translate(${x}, ${y}) `);
			});

		rombGroup
			.append('rect')
			.attr('fill', MAIN_COLOR)
			.attr('width', 9)
			.attr('height', 9)
			.attr('transform', 'translate(6, -6) rotate(45)');

		rombGroup.transition()
			.duration(300)
			.style('opacity', 1);

		$(document)
			.on('mouseover', '[data-map-card]', hoverHandler)
			.on('mouseleave', '[data-map-card]', leaveHover);

		let activePathList = [];
		let activeCards = [];

		/**
		 * Создание карты координат пути на основе координат нодов и их связи
		 *
		 * @param nodeMap
		 * @param nodeCoordMap
		 * @returns {*}
		 */
		function createPathData(nodeMap, nodeCoordMap) {
			return nodeMap.map(([startNode, endNode]) => {
				if (nodeCoordMap[startNode][0] > nodeCoordMap[endNode][0]) {
					return [nodeCoordMap[endNode], nodeCoordMap[startNode], [startNode, endNode]];
				}
				return [nodeCoordMap[startNode], nodeCoordMap[endNode], [startNode, endNode]];
			});
		}

		function hoverHandler() {
			const cardID = this.dataset.mapCard;

			const card = cardMap[cardID];
			activePathList = card.nodeList;

			const activePath = getActiveNodeId(activePathList);

			pathData = createPathData(nodePathMapById, nodeCoordMap);

			activeCards = new Set(activePath.map(nodeId => {
				return +nodeMap[nodeId].parentId;
			}));

			[...activeCards].forEach(card => {
				cardMap[card].html.classList.add('is-active');
			});

			reDrawPath()
		}

		function leaveHover() {
			activePathList = [];
			activeCards = [];

			for (const card in cardMap) {
				cardMap[card].html.classList.remove('is-active');
			}

			reDrawPath();
		}

		/**
		 * Получение цвета лении
		 *
		 * @param d
		 * @returns {MAIN_COLOR|DISABLE_COLOR}
		 */
		function getColorPath(d) {
			return isActivePath(d, MAIN_COLOR, DISABLE_COLOR);
		}

		/**
		 * ПОлучение толщины линий пути
		 *
		 * @param d
		 * @returns {2 | 1}
		 */
		function getStokeWidth(d) {
			return isActivePath(d, 2, 1);
		}

		/**
		 * Получаем значение параметра на основе состояния пути
		 *
		 * @param d - d3 data select object
		 * @param { any } activeVal - значение в случае активного пути
		 * @param { any } disableVal - значение в случае не активного пути
		 * @returns { activeVal | disableVal}
		 */
		function isActivePath(d, activeVal = true, disableVal = false) {
			const [start, end] = d[2];

			if (activePathList.length === 0) {
				return activeVal;
			}

			if (activePathList.includes(start) || activePathList.includes(end)) {
				return activeVal;
			}

			return disableVal;
		}

		window.addEventListener('resize', resize);

		function resize() {
			WIDTH = svgContainer.offsetWidth;
			HEIGHT = svgContainer.offsetHeight;

			nodeCoordMap = getNodesCoords(nodeMap, mainOffset);
			pathData = createPathData(nodePathMapById, nodeCoordMap);

			svg.attr('width', WIDTH)
				.attr('height', HEIGHT);

			svg.selectAll('path').data(pathData)
				.attr('d', function ([[x1, y1], [x2, y2]]) {
					return draw(d3.path(), x1, y1, x1 + BEZIER_OFFSET, y1, x2 - BEZIER_OFFSET, y2, x2, y2);
				});

			svg.selectAll('g')
				.data(pathData)
				.each(function (d) {
					const [[x, y]] = d;
					d3.select(this)
						.attr('transform', `translate(${x}, ${y}) `);
				})
		}

		/**
		 * перерисовываем все пути на основе активных
		 */
		function reDrawPath() {
			path.transition().duration(250)
				.attr('stroke', (d) => getColorPath(d))
				.attr('stroke-width', (d) => getStokeWidth(d))
				.each(function (d) {
					if (isActivePath(d)) {
						d3.select(this).raise(); 		// поднимаем выше по z-index
					}
				});

			rombGroup.each(function (d) {
				if (isActivePath(d)) {
					d3.select(this).raise(); 			// поднимаем выше по z-index
				}
			});
		}

		/**
		 * Рисуем линию между точками
		 * @param context
		 * @param x1
		 * @param y1
		 * @param cpx1
		 * @param cpy1
		 * @param cpx2
		 * @param cpy2
		 * @param x
		 * @param y
		 * @returns {*}
		 */
		function draw(context, x1, y1, cpx1, cpy1, cpx2, cpy2, x, y) {
			context.moveTo(x1, y1);
			context.closePath();
			context.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x, y);
			return context;
		}
	}

	function initMobileRelationships() {
		$(document).on('click', '.b-relationship .b-map-card', function (e) {
			e.preventDefault();

			const cardId = this.dataset.mapCard;
			const card = cardMap[cardId];
			const activePathList = card.nodeList;

			const activePath = getActiveNodeId(activePathList);

			const activeCards = new Set(activePath.map(nodeId => {
				return +nodeMap[nodeId].parentId;
			}).filter(id => id !== +cardId));

			let result = document.createElement('div');
			result.innerHTML = card.html.outerHTML;

			[...activeCards].forEach(card => {
				result.innerHTML += cardMap[card].html.outerHTML;
			});

			$.fancybox.open(result);
		});

		$(document).on('click', '.b-relationship .b-map-node', function (e) {
			e.stopPropagation();

			const nodeId = this.dataset.mapNode;
			const {nodeParent} = this.dataset;

			const activeNodeList = getActiveNodeId([+nodeId]);

			if (0 === activeNodeList.length) {
				return;
			}

			const activeCards = new Set(activeNodeList.map(nodeId => {
				return +nodeMap[nodeId].parentId;
			}).filter(id => id !== +nodeParent));

			let result = document.createElement('div');
			result.innerHTML = cardMap[nodeParent].html.outerHTML;

			[...activeCards].forEach(card => {
				result.innerHTML += cardMap[card].html.outerHTML;
			});

			$(result).find('[data-map-node]').each(function () {
				const id = this.dataset.mapNode;
				if (!activeNodeList.includes(+id)) {
					$(this).addClass('is-hide');
				}
			});

			$.fancybox.open(result);
		});
	}
});
